export default __webpack_public_path__ + "static/media/lock.4ce7ae5f.svg";